import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}summit-hr`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const summitApi = {
  updateMemberStatus: (body) => {
    return instance().patch('/members', body)
  }
}
export default summitApi



// WEBPACK FOOTER //
// ./src/api/summit.js